import Notification from '@veeva/corgix/notification';
import Icon from '@veeva/corgix/icon';
import { css } from '@emotion/react';
import { faExclamationCircle } from '@fortawesome/pro-solid-svg-icons/faExclamationCircle';
import { faTimes as farTimes } from '@fortawesome/pro-regular-svg-icons/faTimes';
import { faCheckCircle } from '@fortawesome/pro-solid-svg-icons/faCheckCircle';
import IconButton from '../components/IconButton';

const types = Object.freeze({
    success: 'success',
    error: 'error',
});

const icons = {
    success: faCheckCircle,
    error: faExclamationCircle,
};

const notification = (title, message, type, close) => {
    let notificationID;

    const notificationMessageCSS = ({ black }) => css`
        position: relative;
        box-sizing: border-box;
        display: flex;
        align-items: flex-start;
        color: ${black};
        overflow: hidden;
        flex-wrap: nowrap;
        margin: -1rem;
    `;

    const iconCSS = ({ redDefault, greenDefault }) => css`
        &.svg-inline--fa {
            min-width: 2.667rem;
            min-height: 2.667rem;
            padding-right: 0.666rem;
        }

        padding-right: 0.66rem;
        color: ${type === types.error ? redDefault : undefined};
        color: ${type === types.success ? greenDefault : undefined};
    `;

    const titleCSS = css`
        font-size: 1.167rem;
        font-weight: bold;
        margin-bottom: 0.5rem;
        display: block;
    `;

    const closeIconCSS = ({ black, silverLight }) => css`
        :not([disabled]) {
            border-radius: 100%;
            margin: 0.583rem 0.583rem 0 auto;
            min-height: 2rem;
            min-width: 2rem;
            width: 2rem;
            height: 2rem;
            display: flex;
            align-items: center;
            justify-content: center;

            svg {
                min-width: 1.1666rem;
                min-height: 1.1666rem;
                cursor: pointer;
                color: ${black};
            }

            &:hover,
            &:focus,
            &:active {
                background-color: ${silverLight};

                > svg:first-of-type {
                    color: ${black};
                }
            }
        }
    `;

    const closeNotification = () => {
        Notification.close(notificationID);
        close?.();
    };

    const leftContent = css`
        padding: 1rem;
        padding-right: 0;
        display: flex;
    `;

    const Content = (
        <div css={notificationMessageCSS}>
            <div css={leftContent}>
                <Icon css={iconCSS} type={icons[type]} />
                <div>
                    <span css={titleCSS}>{title}</span>
                    <div>{message}</div>
                </div>
            </div>
            <IconButton css={closeIconCSS} onClick={closeNotification} icon={farTimes} />
        </div>
    );

    const customNotification = {
        message: Content,
        transient: false,
        duration: 10000,
        placement: 'topcenter',
    };

    notificationID = Notification.basic(customNotification);
    return notificationID;
};

const error = (title, message, errorID, timestamp, closeNotification) => {
    const content = (
        <div>
            {message}
            {errorID && <div>{errorID}</div>}
            {timestamp && <div>{timestamp}</div>}
        </div>
    );

    return notification(title, content, types.error, closeNotification);
};

const success = (title, message) => {
    return notification(title, message, types.success);
};

const close = (notificationID) => {
    if (notificationID) {
        Notification.close(notificationID);
    }
};

export default {
    error,
    success,
    close,
};
